import { render, staticRenderFns } from "./ProductSaleList.vue?vue&type=template&id=3dfd3920&scoped=true&"
import script from "./ProductSaleList.vue?vue&type=script&lang=js&"
export * from "./ProductSaleList.vue?vue&type=script&lang=js&"
import style0 from "./ProductSaleList.vue?vue&type=style&index=0&id=3dfd3920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfd3920",
  null
  
)

export default component.exports